import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMetodosDosimetria, getTiposDosimetria } from "../../../../../../../../../../../redux/actions/resolucion";
import DosimetriaForm from "./DosimetriaForm";

const initialValues = {
    tipoDosimetria: null,
    metodoDosimetria: null,
    cantidadPersonal: "",
    cuitResponsable: "",
};

const DosimetriaFormContainer = ({ open, handleClose, handleSubmit, values }) => {
    const dispatch = useDispatch();
    const tiposDosimetria = useSelector(
        (state) => state.resolucion.tiposDosimetria
    );
    const metodosDosimetria = useSelector(
        (state) => state.resolucion.metodosDosimetria
    );
    const [formInitialValues, setFormInitialValues] = useState();
    const [loadingTiposDosimetria, setLoadingTiposDosimetria] = useState(true);
    const [loadingMetodosDosimetria, setLoadingMetodosDosimetria] = useState(true);

    useEffect(() => {
        if (open) {
            if (tiposDosimetria.data.length === 0) {
                dispatch(getTiposDosimetria()).finally(() => {
                    setLoadingTiposDosimetria(false);
                });
            } else {
                setLoadingTiposDosimetria(false);
            }

            if (metodosDosimetria.data.length === 0) {
                dispatch(getMetodosDosimetria()).finally(() => {
                    setLoadingMetodosDosimetria(false);
                });
            } else {
                setLoadingMetodosDosimetria(false);
            }

            if (values) setFormInitialValues(values);
            else {
                setFormInitialValues(initialValues)
            }
        } else {
            setLoadingMetodosDosimetria(true);
            setLoadingTiposDosimetria(true);
        }
    }, [values, open])

    return (
        <DosimetriaForm
            open={open}
            loading={loadingTiposDosimetria || loadingMetodosDosimetria}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            initialValues={formInitialValues}

        />
    )

}

export default DosimetriaFormContainer;
